import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { getLocale } from '@websky/core/src/utils';
import Link from '@websky/core/src/Link';
export const renderCheckoutLinksLabel = companyInfo => {
    const { t } = useTranslation('Checkout');
    const currentLocale = getLocale();
    const hasPrivacyPolicy = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.privacyPolicy;
    const passengerRules = `https://armenianairlines.am/${currentLocale}/transportation-condition`;
    const baggageRules = `https://armenianairlines.am/${currentLocale}/baggage`;
    return (React.createElement(React.Fragment, null,
        t('I accept the'),
        ' ',
        React.createElement(Link, { action: () => { } },
            React.createElement("span", { "data-type": "termsOfTariff" }, t('terms of tariff'))),
        ",\u00A0",
        React.createElement(Link, { target: '_blank', action: passengerRules }, t('passenger transportation')),
        ' ',
        t('and'),
        "\u00A0",
        React.createElement(Link, { target: "_blank", action: baggageRules }, t('baggage transportation')),
        hasPrivacyPolicy && (React.createElement(React.Fragment, null,
            ' ',
            t('and'),
            "\u00A0",
            React.createElement(Link, { target: '_blank', action: companyInfo.privacyPolicy }, t('processing of my personal data')))),
        t('infoLinksLabel_end', {
            defaultValue: '',
            fallbackLng: 'en'
        })));
};
